// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"Error_pageWrapper__2ZpP8","errorWrapper":"Error_errorWrapper__Wk_bC"};